import React, {useEffect, useState} from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    Table,
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import Pagination from "../Pagination/Pagination";
import LogsFilter from "./LogsFilter";
import {getCompanyLogsAction, getCompanySubscriptionsAction} from "../../../../redux/actions/AdminActions";
import {getCompanyLogsSelector, getCompanySubscriptionsSelector} from "../../../../redux/selectors/AdminSelector";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import moment from "moment";

const Logs = ({statsModal, setStatsModal, companyId, loadCompanyLogsData, companyLogsData}) => {
    const [query, setQuery] = useState({});
    const [sort, setSort] = useState(["createdAt", "ASC"]);
    const [trackSort, setTrackSort] = useState(0);

    useEffect(() => {
        if (companyId) onSubmit();
    }, [companyId, query, sort])

    const onSubmit = (page = 1) => {
        const data = {
            "company_id": companyId,
            "filter_options": {
                ...query,
                "sort_array": [sort]
            },
            "pagination": {
                "page": page,
                "size": 10
            }
        }
        loadCompanyLogsData(data)
    }

    return (
        <>
            <LogsFilter query={query} setQuery={setQuery}/>
            <Card className="mb-2">
                <CardBody>
                    <div>
                        <div>
                            <h4>Logs</h4>
                        </div>
                        <hr/>
                    </div>
                    <Table responsive className="custom-table text-dark">
                        <thead>
                        <tr>
                            <th
                                style={{overflow: "hidden", cursor: "pointer"}}
                                onClick={() => {
                                    setSort((prev) => {
                                        return prev[0] === "user_name" && prev[1] === "ASC"
                                            ? ["user_name", "DESC"]
                                            : ["user_name", "ASC"];
                                    });
                                    setTrackSort(1);
                                }}
                            >
                                USERNAME
                                <span className="ml-1">
                                    {trackSort === 1 ? (
                                        sort[1] === "DESC" ? (
                                            <i className="fa fa-arrow-down"/>
                                        ) : (
                                            <i className="fa fa-arrow-up"/>
                                        )
                                    ) : (
                                        ""
                                    )}
                                </span>
                            </th>
                            <th
                                style={{overflow: "hidden", cursor: "pointer"}}
                                onClick={() => {
                                    setSort((prev) => {
                                        return prev[0] === "model" && prev[1] === "ASC"
                                            ? ["model", "DESC"]
                                            : ["model", "ASC"];
                                    });
                                    setTrackSort(2);
                                }}
                            >
                                MODEL NAME
                                <span className="ml-1">
                                    {trackSort === 2 ? (
                                        sort[1] === "DESC" ? (
                                            <i className="fa fa-arrow-down"/>
                                        ) : (
                                            <i className="fa fa-arrow-up"/>
                                        )
                                    ) : (
                                        ""
                                    )}
                                </span>
                            </th>
                            <th
                                style={{overflow: "hidden", cursor: "pointer"}}
                                onClick={() => {
                                    setSort((prev) => {
                                        return prev[0] === "name" && prev[1] === "ASC"
                                            ? ["name", "DESC"]
                                            : ["name", "ASC"];
                                    });
                                    setTrackSort(3);
                                }}
                            >
                                ACTION
                                <span className="ml-1">
                                    {trackSort === 3 ? (
                                        sort[1] === "DESC" ? (
                                            <i className="fa fa-arrow-down"/>
                                        ) : (
                                            <i className="fa fa-arrow-up"/>
                                        )
                                    ) : (
                                        ""
                                    )}
                                </span>
                            </th>
                            <th
                                style={{overflow: "hidden", cursor: "pointer"}}
                                onClick={() => {
                                    setSort((prev) => {
                                        return prev[0] === "url" && prev[1] === "ASC"
                                            ? ["url", "DESC"]
                                            : ["url", "ASC"];
                                    });
                                    setTrackSort(4);
                                }}
                            >
                                URL
                                <span className="ml-1">
                                    {trackSort === 4 ? (
                                        sort[1] === "DESC" ? (
                                            <i className="fa fa-arrow-down"/>
                                        ) : (
                                            <i className="fa fa-arrow-up"/>
                                        )
                                    ) : (
                                        ""
                                    )}
                                </span>
                            </th>
                            <th
                                style={{overflow: "hidden", cursor: "pointer"}}
                                onClick={() => {
                                    setSort((prev) => {
                                        return prev[0] === "created_at" && prev[1] === "ASC"
                                            ? ["created_at", "DESC"]
                                            : ["created_at", "ASC"];
                                    });
                                    setTrackSort(5);
                                }}
                            >
                                CREATED AT
                                <span className="ml-1">
                                    {trackSort === 5 ? (
                                        sort[1] === "DESC" ? (
                                            <i className="fa fa-arrow-down"/>
                                        ) : (
                                            <i className="fa fa-arrow-up"/>
                                        )
                                    ) : (
                                        ""
                                    )}
                                </span>
                            </th>
                            {/*<th>*/}
                            {/*    ACTION*/}
                            {/*</th>*/}
                        </tr>
                        </thead>
                        <tbody>
                        {
                            companyLogsData?.Logs?.data?.map((item, key) => {
                                    return (
                                        <tr key={item?.id}>
                                            <td>{item?.User?.first_name} {item?.User?.last_name}</td>
                                            <td>{item?.model_name}</td>
                                            <td>{item?.action}</td>
                                            <td>{item?.url}</td>
                                            <td>{item?.createdAt ? moment(item?.createdAt).format("MMM DD, YYYY") : "N/A"}</td>
                                            {/*<td>*/}
                                            {/*    <UncontrolledDropdown>*/}
                                            {/*        <DropdownToggle href="#" className="card-drop" tag="i">*/}
                                            {/*            <i className="mdi mdi-dots-horizontal font-size-18"/>*/}
                                            {/*        </DropdownToggle>*/}
                                            {/*        <DropdownMenu right>*/}
                                            {/*            <DropdownItem className="text-primary"*/}
                                            {/*                          onClick={() => setStatsModal(true)}>*/}
                                            {/*                View State*/}
                                            {/*            </DropdownItem>*/}
                                            {/*        </DropdownMenu>*/}
                                            {/*    </UncontrolledDropdown>*/}
                                            {/*</td>*/}
                                        </tr>
                                    )
                                }
                            )
                        }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
            <div className="d-flex justify-content-center">
                <Pagination
                    pages={companyLogsData?.Logs?.totalPages}
                    page={companyLogsData?.Logs?.currentPage}
                    setPage={(page) => onSubmit(page)}
                    count={companyLogsData?.Logs?.totalItems}
                />
            </div>
        </>
    )
}


const mapDispatchToProps = (dispatch) => {
    return {
        loadCompanyLogsData: (data) => dispatch(getCompanyLogsAction(data))
    }
}

const mapStateToProp = (state) => {
    return {
        companyLogsData: getCompanyLogsSelector(state)
    }
}

export default withRouter(connect(mapStateToProp, mapDispatchToProps)(Logs))

